import {
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Stack,
  Tooltip,
} from "@mui/material";
import { Box, keyframes } from "@mui/system";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialBox from "../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import { useLocation } from "react-router-dom";
import ReconcileDialog from "./reconciledialog";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { MdOutlineIncompleteCircle } from "react-icons/md";

const ReconcilationRemark = () => {
  const location = useLocation();
  const { data, role } = location.state || {};
  const [row, setrow] = useState([]);
  const [mallentries, setmallentries] = useState({
    agent: "",
    marketName: "",
    contactPerson: "",
    contactNumber: "",
    startdate: "",
    enddate: "",
  });
  const pulse = keyframes`
  0%   { transform: scale(1) rotate(0deg); }
   25%   { transform: scale(1) rotate(90deg); }
  50%  { transform: scale(1.1) rotate(180deg); }
  100% { transform: scale(1) rotate(360deg); }
`;
  const [open, setopen] = useState(false);
  const [currenttype, settype] = useState("");
  const columns = [
    {
      headerName: "Product Code",
      field: "productcode",
      name: "productCode",
      flex: 0.3,
      disableColumnMenu: true,
      editable: false,
    },

    {
      headerName: "Product Name",
      field: "productname",
      name: "productname",
      flex: 0.3,
      editable: false,
      disableColumnMenu: true,
    },
    {
      headerName: "Action",
      field: "action",
      name: "action",
      flex: 0.3,

      editable: false,
      disableColumnMenu: true,
    },
  ];
  const [products, setproducts] = useState([]);

  useEffect(() => {
    if (data) {
      setmallentries({
        agent: data?.agent?.employeeName,
        marketName: data?.marketName,
        contactPerson: data?.contactPerson,
        contactNumber: data?.contactNumber,
        startdate: data?.contractStart,
        enddate: data?.contractEnd,
      });
      let rowwdata = data?.agreedProducts;

      rowwdata = rowwdata.map((row, ind) => ({
        id: ind,
        agreedprodid: row?.id,
        productid: row?.product?.id,
        productcode: row?.product?.productCode,
        productname: row?.product?.productName,
        action: (
          <div style={{ display: "flex", justifyContent: "flex-start" }}>
            <IconButton
              onClick={() =>
                handledilog("reconcile", {
                  ...row,
                  enddate: data?.contractEnd,
                  mallid: data?.id,
                })
              }
            >
              <Tooltip title={"Reconcile"}>
                <SyncAltIcon sx={{ color: "#1E88E5" }} />
              </Tooltip>
            </IconButton>

            <IconButton
              onClick={() =>
                handledilog("remark", { ...row, mallid: data?.id })
              }
            >
              <Tooltip title={"Remarks"}>
                <NoteAltIcon sx={{ color: "#AAA800" }} />
              </Tooltip>
            </IconButton>

            <IconButton size="small">
              {row?.reconciliationSet?.length > 0 ? (
                (Number(row?.reconciliationSet?.[0]?.actualQuantity ?? 0) /
                  Math.max(1, Number(row?.quantity ?? 0))) *
                  100 >
                95 ? (
                  <Tooltip
                    title={
                      "Actual Quantity is More than 95 % of Agreed Quantity"
                    }
                  >
                    <ThumbUpIcon size={20} sx={{ color: "green" }} />
                  </Tooltip>
                ) : (
                  <Tooltip
                    title={
                      "Actual Quantity is Less than 95 % of Agreed Quantity"
                    }
                  >
                    <ThumbDownAltIcon size={20} sx={{ color: "red" }} />
                  </Tooltip>
                )
              ) : (
                <Tooltip
                  title="Reconciliation yet to be done"
                  arrow
                  enterTouchDelay={0}
                >
                  <Box
                    component="span"
                    sx={{
                      display: "inline-flex",
                      color: "orange",
                      transformOrigin: "center",
                      animation: `${pulse} 3.2s ease-in-out infinite`,
                      willChange: "transform",
                    }}
                  >
                    <MdOutlineIncompleteCircle size={22} />
                  </Box>
                </Tooltip>
              )}
            </IconButton>
          </div>
        ),
      }));
      setproducts(rowwdata);
    }
  }, []);
  const submitreconcile = () => {};
  const handledilog = (type, row) => {
    setrow(row);
    settype(type);
    setopen(true);
  };

  return (
    <DashboardLayout>
      <ReconcileDialog
        open={open}
        onClose={() => setopen(false)}
        onSubmit={submitreconcile}
        type={currenttype}
        data={row}
        role={role}
      />
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Reconcilation and Remark
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    MarketName <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={mallentries.marketName}
                  name="marketName"
                  disabled={true}
                />
              </Grid>

              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Agent <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={mallentries.agent}
                  name="marketName"
                  disabled={true}
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    ContactPerson <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={mallentries.contactPerson}
                  name="contactPerson"
                  disabled={true}
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Contact Number<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={mallentries.contactNumber}
                  name="contactNumber"
                  disabled={true}
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Contract Start Date<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={mallentries?.startdate}
                  type="date"
                  name="contractStart"
                  placeholder="Enter contractStart"
                  disabled={true}
                />
              </Grid>

              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Contract End Date<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={mallentries?.enddate}
                  type="date"
                  name="contractStart"
                  disabled={true}
                />
              </Grid>
            </Grid>

            <MaterialDataGrid
              rows={products}
              columns={columns}
              isSelectable={false}
              localeText={{
                noRowsLabel: (
                  <Stack
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    spacing={1}
                  >
                    <MaterialTypography
                      variant="body2"
                      fontWeight="medium"
                      color="text"
                    >
                      No Product Master found
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                      You have not yet add any Product Master details. Click on
                      the "Add Product Master" button to start adding Product
                      Master details.
                    </MaterialTypography>
                  </Stack>
                ),
              }}
            />
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};
export default ReconcilationRemark;
